import { LazyAction, LazyModule } from 'owa-bundling';
import type * as undoActions from 'owa-mail-undo/lib/lazyFunctions';

const lazyUndoModule: LazyModule<typeof undoActions> = new LazyModule<typeof undoActions>(
    () => import('owa-mail-undo/lib/lazyFunctions'),
    {
        name: 'MailUndoActions',
    }
);

export const lazyUndo: LazyAction<typeof undoActions.undo, typeof lazyUndoModule> = new LazyAction(
    lazyUndoModule,
    m => m.undo
);
